import { Editor, Range, Transforms } from 'slate';
import { copyProperties } from 'utilities';
import HelptapEditor from '../../helpers';

export default function withDeleteBackwardBehaviour(editor) {
  const { deleteBackward } = editor;

  const overrides = {
    deleteBackward(unit = 'character', ...rest) {
      const { selection } = editor;

      if (selection && Range.isCollapsed(selection)) {
        const topLevelNodePath = HelptapEditor.getClosestEditableNodePath(editor);

        if (topLevelNodePath !== null) {
          const [topLevelNode] = Editor.node(editor, topLevelNodePath);

          // const handled = HelptapEditor.handleDeleteBackward(editor, topLevelNode, topLevelNodePath);
          // if (handled === true) return;
        }

        // Word deletion (Alt+Backspace)
        if (editor.deleteBackwardMode === 'word') {
          deleteBackward('word', ...rest);
          return;
        }

        // Line deletion (Meta/Command/Win+Backspace)
        if (editor.deleteBackwardMode === 'line') {
          const blockEntry = Editor.above(editor, { match: n => Editor.isBlock(editor, n) });
          if (blockEntry) {
            const [, path] = blockEntry;
            const blockStart = Editor.start(editor, path);
            Transforms.delete(editor, { at: { anchor: selection.anchor, focus: blockStart } });
            return;
          }
        }

        // Default single character delete
        deleteBackward(unit, ...rest);

        HelptapEditor.trySelectPreviousNode(editor);
      }
    }
  };

  return copyProperties(overrides, editor);
}